// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import ImportTableController from "./import_table_controller"
application.register("import-table", ImportTableController)

import PurchaseImportController from "./purchase_import_controller"
application.register("purchase-import", PurchaseImportController)

import InventoryUpdateRunController from "./inventory_update_run_controller"
application.register("inventory-update-run", InventoryUpdateRunController)

import InventoryGeneratorController from "./inventory_generator_controller"
application.register("inventory-generator", InventoryGeneratorController)

import InventoryToolbarController from "./inventory_toolbar_controller"
application.register("inventory-toolbar", InventoryToolbarController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import NotificationPreviewController from "./notification_preview_controller"
application.register("notification-preview", NotificationPreviewController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ProductMultiController from "./product_multi_controller"
application.register("product-multi", ProductMultiController)

import ProductProfitController from "./product_profit_controller"
application.register("product-profit", ProductProfitController)

import PromptRejectController from "./prompt_reject_controller"
application.register("prompt-reject", PromptRejectController)

import QrEditorController from "./qr_editor_controller"
application.register("qr-editor", QrEditorController)

import QrPreviewController from "./qr_preview_controller"
application.register("qr-preview", QrPreviewController)

import ScannerController from "./scanner_controller"
application.register("scanner", ScannerController)

import ScannedProductsController from "./scanned_products_controller"
application.register("scanned-products", ScannedProductsController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SizeFieldsController from "./size_fields_controller"
application.register("size-fields", SizeFieldsController)

import SaleEditorController from "./sale_editor_controller"
application.register("sale-editor", SaleEditorController)

import SaleOrderWorkspaceController from "./sale_order_workspace_controller"
application.register("sale-order-workspace", SaleOrderWorkspaceController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import PrintQueueController from "./print_queue_controller"
application.register("print-queue", PrintQueueController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import WindowController from "./window_controller"
application.register("window", WindowController)

import WindowManagerController from "./window_manager_controller"
application.register("window-manager", WindowManagerController)

import CashDrawerController from "./cash_drawer_controller"
application.register("cash-drawer", CashDrawerController)

import ReturnsController from "./returns_controller"
application.register("returns", ReturnsController)

import CajaWindowManagerController from "./caja_window_manager_controller"
application.register("caja-window-manager", CajaWindowManagerController)

import ManualSelectController from "./manual_select_controller"
application.register("manual-select", ManualSelectController)

import ManualEditController from "./manual_edit_controller"
application.register("manual-edit", ManualEditController)
